import { getModuleFlags } from '../../access/moduleAccess';

export const LEGACY_POS_BASE = '/pos';
export const PREMIUM_POS_BASE = '/premium-pos';

function hasPrefix(path: string, prefix: string): boolean {
  return path === prefix || path.startsWith(`${prefix}/`) || path.startsWith(`${prefix}?`);
}

/** `premiumPosPath('sales/new')` -> `/premium-pos/sales/new`; `premiumPosPath()` -> `/premium-pos`. */
export function premiumPosPath(sub = ''): string {
  const rest = sub.replace(/^\/+/, '');
  return rest ? `${PREMIUM_POS_BASE}/${rest}` : PREMIUM_POS_BASE;
}

export function isLegacyPosPath(path: string): boolean {
  return hasPrefix(path, LEGACY_POS_BASE);
}

export function isPremiumPosPath(path: string): boolean {
  return hasPrefix(path, PREMIUM_POS_BASE);
}

/** Swaps a `/premium-pos...` prefix for `/pos...`; other paths are returned unchanged. */
export function toLegacyPosPath(path: string): string {
  return isPremiumPosPath(path) ? LEGACY_POS_BASE + path.slice(PREMIUM_POS_BASE.length) : path;
}

/** Swaps a `/pos...` prefix for `/premium-pos...`; other paths are returned unchanged. */
export function toPremiumPosPath(path: string): string {
  return isLegacyPosPath(path) ? PREMIUM_POS_BASE + path.slice(LEGACY_POS_BASE.length) : path;
}

/** Base path of whichever POS module the company currently exposes. */
export function activePosBase(): string {
  return getModuleFlags().isPOSEnabled ? PREMIUM_POS_BASE : LEGACY_POS_BASE;
}
